import { User } from "./user";
import { ManagerDTO } from "./manager";
import { Task } from "./task";

export enum TaskUserStatus {
    Assigned = "Assigned",
    Selected = "Selected",
    Confirmed = "Confirmed",
    Rejected = "Rejected",
    Replaced = "Replaced",
    Working = "Working",
    Completed = "Completed",
}

export interface TaskUserDTO {
    id: string;
    taskId: string;
    userId: string;
    status: TaskUserStatus;
    assignedAt: string;
    updatedAt: string;
    rejectionReason?: string;
    managerId?: string;
    task?: Task;
    user?: User;
    manager?: ManagerDTO;
}
